import {ENI, ESSO, IP, LONG_TERM, Q8, SHARING, SHORT_TERM} from "./FuelsConstants";
import {useTranslation} from "react-i18next";


export const useRegistryFuelCardBusiness = () => {

    const {t} = useTranslation(['finance'], {keyPrefix: 'registryFuelCard.filters.business'});


    const getRegistryFuelCardBusiness = (business: string) => {
        switch (business) {

            case SHARING:  return t('SHARING');
            case SHORT_TERM:   return t('SHORT_TERM');
            case LONG_TERM: return t('LONG_TERM');

            default : return '-'
        }
    };


    const business = [
        {
            value: SHARING,
            label: getRegistryFuelCardBusiness(SHARING)
        },
        {
            value: SHORT_TERM,
            label: getRegistryFuelCardBusiness( SHORT_TERM)
        },
        {
            value: LONG_TERM,
            label: getRegistryFuelCardBusiness( LONG_TERM)
        }
    ];

    return {
        business, getRegistryFuelCardBusiness
    }
}